<template>
  <div>
    <mdb-modal size="lg" @shown="componentDidMount" :show="visible" @close="closeModal">
      <mdb-modal-header>
        <mdb-modal-title>Order Partner Attachments</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body v-if="order!=null">
            <h3 class="h3-responsive font-weight-bold">{{order.merchant.name}}</h3>
            <hr />
            <mdb-row class="py-1" v-for="item in order.all_items" style="border-bottom: 1px solid grey" :key="item.id">
                <mdb-col col="1">
                    <div class="text" :class="{'text-danger': item.is_available==0}">{{item.quantity}}x</div>
                </mdb-col>
                <mdb-col col="9" class="text grey lighten-4 rounded">
                    <div :class="{'text-danger': item.is_available==0}">
                        {{item.allproduct.allcategory.name}}
                    </div>
                    <div v-if="order.status=='NEW'" class="font-weight-bold d-flex flex-column">
                        <div v-if="order.service_id==2">{{item.allproduct.merchant.name}}</div>
                        <mdb-tooltip v-if="item.is_available==1" trigger="hover" :options="{placement: 'top'}">
                            <span slot="tip">Click to remove item</span>
                            <a slot="reference" target="_blank" @click="itemNotAvailable(item)">
                                {{item.name}} <mdb-icon class="text-danger" far icon="trash-alt" />
                            </a>
                        </mdb-tooltip>
                        <div v-if="item.is_available==0" class="d-flex flex-row align-items-center text-danger">
                            {{item.name}} 
                            <mdb-icon v-if="item.is_available==0" class="ml-1" icon="times" />
                        </div>
                    </div>
                    <div v-if="order.status!='NEW'" class="font-weight-bold d-flex flex-column">
                        <div v-if="order.service_id==2">{{item.allproduct.merchant.name}}</div>
                        <div class="d-flex flex-row align-items-center" :class="{'text-danger': item.is_available==0}">
                            {{item.name}} 
                            <mdb-icon v-if="item.is_available==0" class="text-danger ml-1" icon="times" /> 
                            <mdb-icon v-if="item.is_available==1" class="text-success ml-1" icon="check" />
                        </div>
                    </div>
                    <div style="font-size: 0.75rem" :class="{'text-danger': item.is_available==0}">
                        {{item.allproduct.description}}
                    </div>
                    <div v-for="variety in item.std_variety" :key="variety.id">
                        {{variety.name}}: <span v-for="option in variety.options" :key="option.name">
                            <span v-if="option.checked">{{option.name}} ({{parseFloat(option.price).toFixed(2)}})</span>
                        </span>
                    </div>
                    <div v-if="item.remarks" :class="{'text-danger': item.is_available==0}">Remarks: {{item.remarks}}</div>
                </mdb-col>
                <mdb-col col="2" class="text-right">
                    <div class="text" :class="{'text-danger': item.is_available==0}">RM {{item.service_charge_node.amount}}</div>
                </mdb-col>
            </mdb-row>
            <mdb-row class="mb-3 my-5">
                <mdb-col col="12">
                    <select :disabled="order.pb_amount!=0" v-model="order.pb_user_id" class="browser-default custom-select">
                        <option :value="null" disabled selected>Select Payer</option>
                        <option value="0">Lapar</option>
                        <option :value="order.partner_user.id">{{order.partner_user.partner_profile.fullname}}</option>
                    </select>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col v-for="(image,index) in attachments" v-bind:key="image.image_url+'_'+index" col="3" class="d-flex flex-column align-items-center">
                    <img @click="showLightBox(index)" class="waves-effect img-fluid" :src="renderAttachment(image.image_url)" />
                    <mdb-btn v-if="image.status=='NEW'" class="top-right-btn" @click="deleteAttachment(index)" color="danger" size="sm"><mdb-icon icon="times" /></mdb-btn>
                    <mdb-input :disabled="order.pb_amount!=0" outline type="text" placeholder="RM" v-model="image.amount" />
                </mdb-col>
            </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer v-if="order">
        <mdb-spinner v-if="loading" small color="blue"/>
        <div v-if="!loading && order.pb_amount==0" class="d-flex flex-row justify-content-between">
            <mdb-btn v-if="!loading" @click="showAttachmentUpload">Add Attachments</mdb-btn>
            <mdb-btn @click="submitPartnerAttachments" v-if="!loading" color="success">Approve RM {{parseFloat(total_attachment_amount).toFixed(2)}}</mdb-btn>
            <mdb-btn @click="rejectPartnerAttachments" v-if="!loading" color="danger">Reject</mdb-btn>
        </div>
        <div v-if="!loading && order.pb_amount!=0" class="flex-row">
            Total PB Amount: <strong> RM {{order.pb_amount}}</strong>
            <mdb-btn @click="closeModal" v-if="!loading" color="danger">Close</mdb-btn>
        </div>
      </mdb-modal-footer>
      <input multiple type="file" @change="attachmentUpload" id="document-upload" hidden />
      <mdb-lightbox
        :visible="lightbox_modal"
        :imgs="lightbox_imgs"
        :index="lightbox_index"
        @hide="lightbox_modal=false"
        ></mdb-lightbox>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbSpinner, mdbRow, mdbCol, mdbIcon,
  mdbInput, mdbLightbox } from 'mdbvue';
  import {APP_FILE_URL} from '../js/config';
  import {fileUploadAjax, ajax} from '../js/ajax';
//   import {getColor} from '../js/colors';
  import {checkPermissionsBinary} from '../js/helper';
  import {validateNumber} from '../js/validation';

    export default {
        components: {
        mdbModal, mdbIcon, mdbInput,
        mdbModalHeader, mdbSpinner,
        mdbModalTitle, mdbLightbox,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn, mdbRow, mdbCol
        },
        props: ['visible', 'close', 'order', 'callback'],
        data: ()=>({
            loading: false,
            attachments: [],
            lightbox_modal: false,
            lightbox_imgs:[],
            lightbox_index:0,
            total_attachment_amount: 0
        }),
        methods: {
            componentDidMount(){
                this.attachments=this.order.service_order_partner_attachments;
                this.order.all_items.forEach(element => {
                    element.std_variety=JSON.parse(element.variety);
                });
            },
            closeModal(){
                this.attachments=[];
                this.lightbox_imgs=[];
                this.lightbox_index=0;
                this.lightbox_modal=false;
                this.close();
            },
            renderAttachment(image=null){
                return image?APP_FILE_URL+image:require('@/assets/picture.png');
            },
            deleteAttachment(index){
                var temp=[...this.attachments];
                temp.splice(index, 1);
                this.attachments=temp;
            },
            showLightBox(index){
                var temp_images=[];
                this.attachments.forEach(element => {
                    temp_images.push(APP_FILE_URL+element.image_url);
                });
                this.lightbox_modal=true,
                this.lightbox_imgs=temp_images,
                this.lightbox_index=index;
            },
            showAttachmentUpload(){
                document.getElementById("document-upload").click();
            },
            attachmentUpload(event){
                this.loading=true;
                fileUploadAjax({
                    url: "admin/upload_service_order_attachments",
                    data: {event: event.target.files},
                    complete: ()=>this.loading=false,
                    success: result=>{
                        result.data.forEach(element => {
                            let obj=new Object();
                            obj.image_url=element;
                            obj.amount=0;
                            obj.status="NEW";
                            this.attachments=this.attachments.concat(obj);
                        });
                    },
                    isShowAlert: true
                }, this)
            },
            submitPartnerAttachments(){
                if(!checkPermissionsBinary(69, this.$store.state.permissions)){
                    this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
                    return false;
                }   
                let validation_continue=true;
                this.attachments.forEach(element => {
                    if(!validateNumber(element.amount)){
                        validation_continue=false;
                    }
                });
                if(!validation_continue){
                    this.$notify.error({message: "Invalid Attachment Amount", position: 'top right', timeOut: 5000})
                    return false;
                }
                this.loading=true;
                ajax({
                    url: "admin/approve_partner_attachments",
                    data: {service_order_id: this.order.id, attachments: this.attachments, pb_user_id: this.order.pb_user_id},
                    complete: ()=>this.loading=false,
                    success: result=>{
                        this.order=result.data;
                        this.attachments=result.data.service_order_partner_attachments;
                        this.callback?this.callback():null;
                        this.closeModal();
                        this.$notify.success({message: "Partner Attachments Approved", position: 'top right', timeOut: 5000});
                    },
                    isShowAlert: true
                }, this)
            },
            rejectPartnerAttachments(){
                if(!checkPermissionsBinary(69, this.$store.state.permissions)){
                    this.$notify.error({message: "Access Denied.", position: 'top right', timeOut: 5000})
                    return false;
                }
                ajax({
                    url: "admin/reject_partner_attachments",
                    data: {service_order_id: this.order.id},
                    complete: ()=>this.loading=false,
                    success: ()=>{
                        this.close();
                        this.callback?this.callback():null;
                        this.$notify.success({message: "Partner Attachments Rejected", position: 'top right', timeOut: 5000})
                    },
                    isShowAlert: true
                }, this)
            }
        },
        watch: {
            attachments: {
                handler(val){
                    let total_attachment_amount=0;
                    val.forEach(element => {
                        if(validateNumber(element.amount)){
                            total_attachment_amount=total_attachment_amount+parseFloat(element.amount);
                        }
                    });
                    this.total_attachment_amount=total_attachment_amount;
                },
                deep: true
            }
        }
    };
</script>

<style scoped>
</style>